import React, { useEffect, useRef, useState } from 'react';

import Select from 'react-select';
import Skeleton from 'react-loading-skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser, faFilter, faLineChart } from '@fortawesome/free-solid-svg-icons';

import DasboardBarChart from '../../dashboard-app/components/bar-chart/index';
import Layout from 'components/layout/base';
import PageTitleCard from 'components/page-title-card';
import SelectMulti from 'components/_base/multi-select';

import lib from 'helpers/lib';
import DashboardService from 'services/dashboard-service';
import PedidoService from 'services/pedido-service';
import RedeService from 'services/rede-service';
import RepresentadaService from 'services/representada-service';
import CardPanel from 'pages/dashboard-app/components/big-number';
import { flushSync } from 'react-dom';

const Pedidos = ({}) => {
  const data = new Date();

  const [filter, setFilter] = useState({
    representadas: [],
    redes: [],
    ano: data.getFullYear(),
    mes: data.getMonth() + 1
  });

  const [metaContratante, setMetaContratante] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [lojas, setLojas] = React.useState();
  const [representadas, setRepresentadas] = React.useState();
  const [vendedores, setVendedores] = React.useState();
  const [redes, setRedes] = React.useState();

  const [vendedorSelecionado, setVendedorSelecionado] = React.useState();
  const [lojaSelecionada, setLojaSelecionada] = React.useState();

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);
  const [loadedVendedores, setLoadedVendedores] = React.useState(false);
  const [loadedRedes, setLoadedRedes] = React.useState(false);
  const [loadedLojas, setLoadedLojas] = React.useState(false);

  useEffect(() => {
    (async () => {
      getRepresentadas();
      getSelectListLoja();
      getSelectListRede();
      getSelectListVendedor();
    })();
  }, []);

// useEffect(async () => {
//    if (loadedRepresentadas && loadedLojas && loadedRedes && loadedVendedores) {
//      await getMetaCotratante();
//    }
//  }, [loadedRepresentadas, loadedLojas, loadedRedes, loadedVendedores]);

   useEffect(async () => {
     if (vendedores) {
       if (vendedores.length == 1) {
         setVendedorSelecionado(vendedores[0].value);
       }
       await getMetaCotratante();
     }
   }, [vendedores]);

  function getFilterParams() {
    return {
      representadaIds: filter.representadas.map((x) => x.value),
      redeIds: filter.redes.map((x) => x.value),
      mes: filter.mes,
      ano: filter.ano,
      lojaId: lojaSelecionada,
      vendedorId: vendedorSelecionado ?? (vendedores.length == 1? vendedores[0].value : filter.vendedorId)
    };
  }

  async function getRepresentadas() {
    const response = await RepresentadaService.selectListAsync();

    if (response?.data) {
      setRepresentadas(response?.data?.data[0]?.options);

      setFilter((prevFilter) => ({
        ...prevFilter,
        representadaId: response?.data?.data[0]?.options[0]?.value
      }));
    }

    setLoadedRepresentadas(true);
  }

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();

    if (vendedores.data) {
      setVendedores(vendedores.data.data); //([...[{}], ...representadas.data.data]);
    }

    setLoadedVendedores(true);
  }

  async function getSelectListLoja() {
    let lojas = await PedidoService.getSelectListLoja();

    if (lojas.data) {
      setLojas(lojas.data.data); //([...[{}], ...lojas.data.data]);
    }

    setLoadedLojas(true);
  }

  async function getSelectListRede() {
    const result = await RedeService.getSelectList();

    if (result.data) {
      setRedes(result.data.data);
    }

    setLoadedRedes(true);
  }

  async function getMetaCotratante(representada = filter.representada) {
    const params = getFilterParams();

    const response = await DashboardService.getMetaContratanteAsync(params);

    setMetaContratante(response.data.data);
    setIsLoading(false);
  }

  function limpar() {
    setFilter({
      representadas: [],
      redes: [],
      ano: data.getFullYear(),
      mes: data.getMonth() + 1,
      vendedorId: vendedores?.length === 1 ? filter.vendedorId : null
    });
  }

  return (
    <Layout>
      <PageTitleCard title="Evolução Mensal" icon={<FontAwesomeIcon icon={faLineChart} />} />

      <div className="m-0">
        <div className="col-lg-12 pt-3">
          <div>
            <div className="row">
              {/* Representada ---------------------------------------------------------------------- */}
              <div className="col-lg-3" disabled>
                <label>Representada</label>
                <SelectMulti
                  options={representadas}
                  value={filter.representadas}
                  onChange={(options) => setFilter({ ...filter, representadas: options })}
                  //filterOptions={search}
                />
              </div>

              <div className="col-lg-3" disabled>
                <label>Rede</label>
                <SelectMulti
                  options={redes}
                  value={filter.redes}
                  onChange={(options) => setFilter({ ...filter, redes: options })}
                />
              </div>

              <div className="col-lg-3">
                <label>Mês</label>
                <Select
                  className="select-form-control"
                  value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
                  placeholder="Selecione..."
                  options={lib.selectListMeses}
                  isClearable={false}
                  onChange={(item) => {
                    setFilter({ ...filter, mes: item.value });
                  }}
                />
              </div>

              <div className="col-lg-3">
                <label>Ano</label>
                <Select
                  className="select-form-control"
                  value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
                  options={lib.selectListAnos}
                  placeholder="Selecione..."
                  isClearable={false}
                  onChange={(item) => {
                    setFilter({ ...filter, ano: item.value });
                  }}
                />
              </div>

              <div className="col-lg-3 mt-3">
                <label>Vendedor</label>
                <Select
                  className="select-form-control"
                  isClearable={vendedores?.length > 1}
                  clearValue={() => {
                    setVendedorSelecionado({});
                  }}
                  styles={customControlStyles}
                  placeholder="Selecione..."
                  options={vendedores}
                  disabled={vendedores?.length === 1}
                  value={vendedores?.find((x) => x.value === vendedorSelecionado)}
                  onChange={(selectedValue) => {
                    setVendedorSelecionado(selectedValue?.value);
                  }}
                />
              </div>

              <div className="col-lg-3 mt-3">
                <label>Loja</label>
                <Select
                  className="select-form-control"
                  isClearable
                  clearValue={() => {
                    setLojaSelecionada({});
                  }}
                  styles={customControlStyles}
                  placeholder="Selecione..."
                  options={lojas}
                  value={lojas?.find((x) => x.value === lojaSelecionada)}
                  onChange={(selectedValue) => setLojaSelecionada(selectedValue?.value)}
                />
              </div>
            </div>

            <div className="row mt-3 justify-content-end">
              <div className="col-3 text-center">
                <button
                  type="button"
                  className="btn btn-secondary btn-action w-100"
                  onClick={() => limpar()}
                >
                  <FontAwesomeIcon icon={faEraser} /> Limpar
                </button>
              </div>

              <div className="col-3 text-center">
                <button
                  type="button"
                  className="btn btn-secondary btn-action w-100"
                  onClick={() => {
                    flushSync(() => {
                      setIsLoading(true);
                    });

                    getMetaCotratante();
                  }}
                  disabled={isLoading}
                >
                  <FontAwesomeIcon icon={faFilter} /> Filtrar
                </button>
              </div>
            </div>
          </div>

          <hr />

          <div className="row m-0 mt-3">
            <div className="col-lg-12 mb-5">
              {/* <div className="col-lg-12 shadow p-3 mb-5 bg-white rounded border-radius: 150px"> */}
              <CardPanel source={metaContratante} isLoading={isLoading} />
            </div>
          </div>

          {!isLoading ? <DasboardBarChart source={metaContratante} /> : <Skeleton count={10} />}
        </div>
      </div>
    </Layout>
  );
};

export default Pedidos;
